import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function PolicyFooter() {
  return <footer className="w-full bg-[#0f3f4a] text-[#f7f4ec] mt-16" data-id="element-1">
      <div className="max-w-4xl mx-auto px-6 py-10" data-id="element-2">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6" data-id="element-3">
          <div data-id="element-4">
            <p className="font-serif-display text-xl tracking-wide" data-id="element-5">
              LA CONEXIÓN CUÁNTICA
            </p>
            <p className="text-sm text-[#b8d8d8] mt-1" data-id="element-6">
              Facilitación de Salud y Bienestar
            </p>
          </div>
          <div className="flex flex-col sm:items-end gap-2 text-sm" data-id="element-7">
            <a href="https://instagram.com/laconexioncuantica.oficial" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#b8d8d8] transition-colors" data-id="element-8">
              <InstagramIcon className="w-4 h-4" aria-hidden="true" data-id="element-9" />
              @laconexioncuantica.oficial
            </a>
            <a href="mailto:laconexioncuantica2022@gmail.com" className="flex items-center gap-2 hover:text-[#b8d8d8] transition-colors" data-id="element-10">
              <MailIcon className="w-4 h-4" aria-hidden="true" data-id="element-11" />
              laconexioncuantica2022@gmail.com
            </a>
          </div>
        </div>
        <p className="text-xs text-[#b8d8d8]/70 mt-8 text-center sm:text-left" data-id="element-12">
          © {new Date().getFullYear()} La Conexión Cuántica. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}